module.exports = __webpack_public_path__ + "static/media/Colosseum.3613bb08.png";